// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2eio9","productName":"Table_productName__1vo0J"};